import { render } from "./Newsletter.vue?vue&type=template&id=2d0db826"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
script.render = render

export default script